import React from "react";
import { Clock } from "lucide-react";
import { useTranslation } from "react-i18next";
import { StoreAdminDetails } from "../../../../types/modules/admin/StoreAdmin.type";
import { formatTime } from "../../../../utils/formatNumber";

type Props = {
  store: StoreAdminDetails;
};

const OpeningHours: React.FC<Props> = ({ store }) => {
  const { t } = useTranslation();
  const { openingHours } = store;

  const today = new Date()
    .toLocaleString("en-US", { weekday: "short" })
    .toLowerCase()
    .slice(0, 3);

  return (
    <div className="bg-white rounded-2xl shadow-custom-light p-6 space-y-4">
      <h2 className="text-lg font-semibold text-Black mb-2 flex items-center gap-2">
        <Clock className="w-5 h-5 text-primary" /> {t("openingHours")}
      </h2>

      <div className="text-sm space-y-2">
        {["sun", "mon", "tue", "wed", "thu", "fri", "sat"].map((dayKey) => {
          const dayData = openingHours?.find((d) => d.day === dayKey);
          const isToday = dayKey === today;

          return (
            <div
              key={dayKey}
              className={`flex justify-between ${
                isToday ? "text-primary font-semibold" : "text-muted"
              }`}
            >
              <span className="capitalize">{t(dayData?.day??"")}</span>
              {dayData?.openTime && dayData?.closeTime ? (
                <span>
                  {formatTime(dayData.openTime.slice(0, 5))} - {formatTime(dayData.closeTime.slice(0, 5))}
                </span>
              ) : (
                <span className="text-danger">{t("closed")}</span>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default OpeningHours;
